import React from "react"
import { Link } from "gatsby"
import Carousel, { autoplayPlugin, Dots } from "@brainhubeu/react-carousel"
import "@brainhubeu/react-carousel/lib/style.css"

import Button from "../components/button"

class HomeCarousel extends React.Component {
  constructor() {
    super()
    this.state = {
      value: 0,
      slides: [
        (
          <div>
            <p>I focus on building intuitive UX/UI and performant web applications. I'm excited about the intersection of tech, data, climate/sustainability, and beyond.</p>
            <Link to="/work/">
              <Button marginTop="35px">Go to Work</Button>
            </Link>
          </div>
        ),
        (
          <div>
            <p>As a lifelong learner, I'm always looking for opportunities to grow and explore through non-work projects.</p>
            <Link to="/projects/">
              <Button marginTop="35px">Go to Projects</Button>
            </Link>
          </div>
        ),
        (
          <div>
            <p>Prior to coding, I was in the operational side of the independent music business and also moonlighted as a DJ.</p>
            <Link to="/mixes/">
              <Button marginTop="35px">Go to Mixes</Button>
            </Link>
          </div>
        ),
      ]
    }
    this.onchange = this.onchange.bind(this);
  }

  onchange(value) {
    this.setState({ value });
  }

  render() {
    return (
      <div>
        <Carousel
          className="carousel"
          value={this.state.value}
          slides={this.state.slides}
          draggable={true}
          onChange={this.onchange}
          plugins={[
            'infinite',
            {
              resolve: autoplayPlugin,
              options: {
                interval: 4000,
              }
            },
          ]}
          animationSpeed={600}
        />
        <Dots
          className="carousel__dots"
          value={this.state.value}
          onChange={this.onchange}
          number={this.state.slides.length}
        />
      </div>
    )
  }
}

export default HomeCarousel
